var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpam = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5216 0.5C13.7869 0.5 14.0414 0.605431 14.2289 0.793084L19.2073 5.77414C19.3947 5.96166 19.5 6.21593 19.5 6.48106V13.5227C19.5 13.788 19.3946 14.0424 19.207 14.2299L14.2289 19.2072C14.0414 19.3947 13.787 19.5 13.5218 19.5H6.48011C6.21495 19.5 5.96065 19.3947 5.77313 19.2072L0.79302 14.2289C0.605406 14.0414 0.5 13.787 0.5 13.5217V6.48021C0.5 6.215 0.605357 5.96064 0.792893 5.77311L5.77311 0.792893C5.96064 0.605357 6.215 0.5 6.48021 0.5H13.5216ZM13.3999 2.79289C13.2124 2.60536 12.958 2.5 12.6928 2.5H7.30835C7.04305 2.5 6.78863 2.60542 6.60108 2.79305L2.79373 6.60213C2.60629 6.78966 2.501 7.04394 2.501 7.30908V12.6939C2.501 12.959 2.60633 13.2133 2.79381 13.4009L6.60109 17.209C6.78864 17.3966 7.04302 17.502 7.30828 17.502H12.6928C12.958 17.502 13.2124 17.3966 13.3999 17.2091L17.2081 13.4009C17.3956 13.2134 17.501 12.959 17.501 12.6938V7.30821C17.501 7.043 17.3956 6.78864 17.2081 6.60111L13.3999 2.79289ZM9 14C9 13.4477 9.44771 13 10 13C10.5523 13 11 13.4477 11 14C11 14.5523 10.5523 15 10 15C9.44771 15 9 14.5523 9 14ZM9 6C9 5.44772 9.44771 5 10 5C10.5523 5 11 5.44772 11 6V10C11 10.5523 10.5523 11 10 11C9.44771 11 9 10.5523 9 10V6Z",
    fill: "none"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpam);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spam.e7f7c8111c752ca2c22db092e7f2b9ac.svg";